// extracted by mini-css-extract-plugin
export default {"formatterIcon":"customer-sites_formatterIcon__eJ+aP"};